module.exports = __webpack_public_path__ + "images/bannerEN-faaea42b20a743e9e8612c0c80227fd4.jpg";